module.exports = __webpack_public_path__ + "assets/5289332fc6d8de1ace8fcce6eca2e665.mp3";